<template>
  <Label :color="color" class="text-white">{{ text }}</Label>
</template>

<script>
export default {
  props: {
    value: {
      type: [Boolean, Number],
      default: null,
    },
    invertColor: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    color() {
      if (this.invertColor) {
        return this.value ? 'bg-red-500' : 'bg-green-500'
      }

      return this.value ? 'bg-green-500' : 'bg-red-500'
    },
    text() {
      return this.value ? this.$t('form.option.yes') : this.$t('form.option.no')
    },
  },
}
</script>
